<template>
  <div class="d-flex justify-content-between" v-if="allItems.length">
    <div class="text-right m-4">
      <h5 style="font-size: 1vw !important"></h5>
    </div>
    <div class="d-flex" v-if="allItems.length">
      <a style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"
         v-if="modalMessage &&  allItems.length" @click="modalMessageShowModal=true"> دلایل عدم تایید</a>


      <!--      <a  :href="`${this.download_url}/Definition_of_basic_measures/all/pdf/by/id/${id_route}?token=${$cookies.get('id_login')}`"
               style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1" v-show="false" >خروجی
              PDF
            </a>-->


    </div>

  </div>
  <center>
    <div class="alert alert-info" style="width: 10vw;" v-if="modalMessage && !allItems.length"
         @click="modalMessageShowModal=true">دلایل عدم تایید
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal"
         style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>دلایل عدم تایید</p>
        <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
      </div>
      <div>
        <div>
          <p>{{ modalMessageShow }}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="modalMessageShowModal=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        </div>
      </div>
    </div>
  </center>
  <div class="table-responsive p-5" style=" ">
    <center v-show="!allItems.length">
      در انتظار تکمیل / بروزرسانی کاربرگ توسط {{ $route.params.title }}
    </center>
    <center v-show="status_show && allItems.length">
      <div class="alert alert-success">
        تایید نهایی شرکت {{ $route.params.title }} انجام شد
      </div>
    </center>
    <table class="table table-striped" v-show="allItems.length" style="">
      <tbody>
      <tr>
        <th><strong>ردیف</strong></th>
        <th style="width: 15vw;"><strong>
          مسئله
        </strong></th>

        <th><strong>نماگر وضعیت
          بهره‌وری مرتبط با مسئله
        </strong></th>
        <th><strong> سیاست مداخله </strong></th>
        <th><strong> اقدام پیشران بهره‌وری </strong></th>


      </tr>

      <tr class="bg-white" v-for="(item, index) in allItems">
        <td>{{ index + 1 }}</td>
        <td>
          {{ item.title }}
        </td>
         <td>
              <button style="display: inline;line-height: 1.2vw;" @click.prevent="showAllNama(item.id)" class="btn btn-primary btn-submit-1">مشاهده</button>

            </td>
        <td>
          <textarea :id="`title_two_${item.id}`" class="form-control" cols="30" rows="30">{{item.basic_measures_problem && item.basic_measures_problem.intervention_policy}}</textarea>

        </td>
        <td>
          <div class="d-flex align-items-center justify-content-center">
            <button @click.prevent="CompletePropulsionModal(item.id)" class="btn btn-submit-1 btn-primary">
              تکمیل/بروزرسانی
            </button>
          </div>
        </td>


      </tr>


      </tbody>
    </table>
  </div>

  <center class="p-2">
    <hr class="w-75 my-1">
    <div style="overflow-y: scroll; height: 50vw; width: 69vw; overflow-x: hidden"
         :style="allItems.length < 19 ? 'height: auto;' : ''">

      <table class="   table table-striped  '" v-show="allItems.length" style="width: 68vw;">
        <tbody>
        <tr>
          <th><strong> ردیف </strong></th>
          <th><strong> مسئله </strong></th>
          <th><strong> عنوان اقدام </strong></th>
          <th><strong> عنوان فعالیت </strong></th>
          <th><strong> دستگاه همکار </strong></th>
          <th><strong> زمان شروع و پایان فعالیت </strong></th>
        </tr>
        </tbody>
        <tr class="bg-white" v-for="(item, index) in sortedItems" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.problem }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.key }}</td>
          <td>{{ item.partner }}</td>
          <td>{{ item.key_date }}</td>
        </tr>

      </table>
    </div>
  </center>


  <div v-show="MissionModal" dir="rtl" class="modal__error slide-top"
       style="z-index: 2147483647; top: 35%; width: 80vw;">
    <div><p> ماموریت </p>
      <p @click.prevent="MissionModal=!MissionModal">❌</p></div>
    <hr>
    <div class="d-flex">
      <div class="d-flex flex-column">
        <label class="required">عنوان ماموریت </label>
        <input v-model="title" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required">خدمت متناظر</label>
        <input v-model="service" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required">شروع اقدام</label>
        <Vue3PersianDatetimePicker v-model="start_date"></Vue3PersianDatetimePicker>
      </div>
      <div class="d-flex flex-column">
        <label class="required">پایان اقدام</label>
        <Vue3PersianDatetimePicker v-model="end_date"></Vue3PersianDatetimePicker>

      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required">سنجه تحقق اقدام</label>
        <input v-model="gauge" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column">
        <label class="required">هدف کمی‌/‌کیفی </label>
        <input v-model="target" type="text" class="form-control">
      </div>
      <button @click.prevent="store_oneModal" class="btn btn-submit-1 btn-primary my-4"
              style="font-size: 2vw; width: 3vw; margin-right: 1vw;"><span
          style="transform: translateY(0.2vw)">+</span></button>

    </div>
    <br>
    <center v-show="!allItemsOneModal.length">
      اطلاعاتی یافت نشد
    </center>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

      <table v-show="allItemsOneModal.length" class="table table-striped">
        <tbody>
        <tr>
          <th><strong> عنوان ماموریت </strong></th>

          <th><strong> خدمت متناظر</strong></th>

          <th style="width: 8vw;"><strong> فعالیت‌های کلیدی </strong></th>
        </tr>
        <tr v-for="item in allItemsOneModal">
          <td>{{ item.title }}</td>
          <td>{{ item.service }}</td>
          <td>{{ item.start_date }}</td>
          <td>{{ item.end_date }}</td>
          <td>{{ item.gauge }}</td>
          <td>{{ item.target }}</td>

          <td>
            <button @click.prevent="CompleteKeyDefinitions(1)" class="btn btn-submit-1 btn-primary">تکمیل/بروزرسانی
            </button>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
  <center v-if="allItems.length">
    <button @click.prevent="store" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>
  </center>
  <div v-show="PropulsionModal" dir="rtl" class="modal__error slide-top"
       style="z-index: 2147483647; top: 35%; width: 70vw;">
    <div><p> اقدام پیشران </p>
      <p @click="PropulsionModal=!PropulsionModal">❌</p></div>
    <hr>
    <div class="d-flex  justify-content-center flex-wrap align-items-center">
      <div class="d-flex flex-column">
        <label class="required">اقدام پیشران </label>
        <input v-model="title_PropulsionBasicAction" type="text" class="form-control">
      </div>

      <div class="d-flex flex-column mx-2">
        <label class="required">شروع اقدام</label>
        <Vue3PersianDatetimePicker v-model="start_date_PropulsionBasicAction"></Vue3PersianDatetimePicker>
      </div>
      <div class="d-flex flex-column">
        <label class="required">پایان اقدام</label>
        <Vue3PersianDatetimePicker v-model="end_date_PropulsionBasicAction"></Vue3PersianDatetimePicker>

      </div>
      <div class="d-flex flex-column mx-2 col-2">
        <label class="required">دوره چرخه </label>
        <select v-model="periods_id" name="" id="" class="form-select">
          <option v-for="item in all_periods" :value="item.id" selected>{{ item.name }}</option>

        </select>

      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required">وضعیت اقدام </label>
        <select v-model="status_project" name="" id="" class="form-select">
          <option value="1" selected>مصوب</option>
          <option value="2">در حال تصویب</option>
        </select>

      </div>

    </div>
    <div class="d-flex align-items-center justify-content-center">


      <button v-if="!is_update" @click.prevent="store_PropulsionBasicAction_store"
              class="btn btn-submit-1 btn-primary my-4" style="font-size: 0.8vw; width: 3vw; margin-right: 1vw;">ذخیره
      </button>
      <div class="d-flex align-items-center justify-content-center" v-else>
        <button @click.prevent="update_PropulsionBasicAction(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;"
                class="btn btn-primary btn-submit-1">ویرایش
        </button>
        <Reset @click.prevent="resetItems"
               style="width: 1.5vw; height: 1.5vw; transform: translateY(0.5vw); cursor: pointer; margin-right: 1vw;"/>
      </div>
    </div>
    <br>
    <center v-show="!allItemsTreeModal.length">
      اطلاعاتی یافت نشد
    </center>
    <div style="overflow-y: scroll;height: 10vw; width: 100%;">
      <div style="height: 20vw; width: 100%;">

        <table class="table table-striped bg-white  " style="margin-top: 7vw !important;"
               v-show="allItemsTreeModal.length">
          <tbody>
          <tr>
            <th><strong> اقدام پیشران </strong></th>
            <th><strong> زمان شروع اقدام </strong></th>
            <th><strong> زمان پایان اقدام </strong></th>
            <th><strong> سنجه تحقق اقدام </strong></th>
            <th><strong>فعالیت کلیدی</strong></th>
            <th><strong>دوره چرخه </strong></th>
            <th><strong>وضعیت اقدام </strong></th>
            <th>عملیات</th>

          </tr>
          </tbody>
          <tr v-for="item in allItemsTreeModal">
            <td>{{ item.title }}</td>
            <td>{{ item.date_start }}</td>
            <td>{{ item.date_end }}</td>

            <td>
              <div class="d-flex align-items-center justify-content-center">
                <button @click.prevent="fetchData(item.id)"
                        class="btn btn-submit-1 btn-primary">تکمیل/بروزرسانی
                </button>

              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <button @click.prevent="CompleteKeyDefinitions(item.id)"
                        class="btn btn-submit-1 btn-primary">تکمیل/بروزرسانی
                </button>

              </div>
            </td>
            <td>{{ (item.circle && item.circle.name) ?? '--' }}</td>
            <td>{{ item.status_project }}</td>

            <td>
              <div class="d-flex justify-content-evenly">
                <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img"
                                                                      src="/img/pen.6428fd02.svg" alt="edit"></a>
                <a @click.prevent="deleteMethod(item.id)" href="#"><img class="table-delete-img"
                                                                        src="/img/delete.f9fc94bc.svg"
                                                                        alt="delete"></a>
              </div>
            </td>


          </tr>
        </table>
      </div>
    </div>
  </div>
  <div v-show="KeyDefinitionsModal" dir="rtl" class="modal__error slide-top key-definitions-modal"
       style="z-index: 2147483647; top: 45%; width: 70vw;">
    <div><p> فعالیت‌های کلیدی </p>
      <p @click="checkKeysClose">❌</p></div>
    <hr>
    <div class="d-flex">
      <div class="d-flex flex-column">
        <label class="required">عنوان فعالیت </label>
        <textarea v-model="title_task" id="" cols="30" rows="10" class="form-control"></textarea>

      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required"> دستگاه متولی </label>
        <input v-model="trustee_device" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required"> دستگاه همکار </label>
        <input v-model="partner_device" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2" style="min-width: fit-content">
        <label class="required">دوره چرخه</label>
        <select v-model="selectedPeriodId" name="" id="" class="form-select">
          <option v-for="item in all_periods" :value="item.id" :selected="item.status === 1 && !is_update">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="d-flex flex-column mx-2">
        <label class="required">تاریخ شروع فعالیت</label>
        <Vue3PersianDatetimePicker v-model="start_date_task"></Vue3PersianDatetimePicker>
      </div>
      <div class="d-flex flex-column">
        <label class="required">تاریخ پایان فعالیت</label>
        <Vue3PersianDatetimePicker v-model="end_date_task"></Vue3PersianDatetimePicker>
      </div>
    </div>

    <div class="d-flex justify-content-evenly mt-3">
      <div class="d-flex flex-column mx-2 align-items-center justify-content-center">
        <label style="height: 3vw;" class="required">وزن</label>
        <input style="width: 4vw;" v-model.number="weight" type="number" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center justify-content-center">
        <label class="required">پیشرفت مورد انتظار فعالیت در پایان بهار {{ year }}(%) </label>
        <input v-if="spring" :max="100" style="width: 4vw;" v-model.number="expected_progress_spring"
               type="number" class="form-control">
        <input type="text" disabled v-else class="form-control" style="width: 4vw;">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center justify-content-center">
        <label class="required">پیشرفت مورد انتظار فعالیت در پایان تابستان {{ year }}(%) </label>
        <input v-if="summer" :max="100" style="width: 4vw;" v-model.number="expected_progress_summer"
               type="number" class="form-control">
        <input type="text" disabled v-else class="form-control" style="width: 4vw;">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center justify-content-center">
        <label class="required">پیشرفت مورد انتظار فعالیت در پایان پاییز {{ year }}(%) </label>
        <input v-if="autumn" :max="100" style="width: 4vw;" v-model.number="expected_progress_fall"
               type="number" class="form-control">
        <input type="text" disabled v-else class="form-control" style="width: 4vw;">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center justify-content-center">
        <label class="required">پیشرفت مورد انتظار فعالیت در پایان سال {{ year }}(%) </label>
        <input v-if="winter" :max="100" style="width: 4vw;" v-model.number="expected_progress" type="number"
               class="form-control">
        <input type="text" disabled v-else class="form-control" style="width: 4vw;">
      </div>
      <button v-if="!is_updateKey" @click.prevent="saveKeys"
              class="btn btn-submit-1 btn-primary"
              style="font-size: 0.8vw; width: 3vw;padding: 1vw; margin-right: 1vw;transform: translatey(3vw);"> افزودن
      </button>
      <div style="transform: translatey(3vw);" v-else class="d-flex align-items-center justify-content-center">
        <button @click.prevent="updateKey(index_key)"
                style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ویرایش
        </button>
        <Reset @click.prevent="resetItemsKey"
               style="width: 1.5vw; height: 1.5vw; transform: translateY(0.5vw); cursor: pointer; margin-right: 1vw;"/>
      </div>
    </div>
    <br>

    <div class="row justify-content-center my-3">
<!--      <div class="col-4">-->
<!--        <div class="d-flex flex-column align-items-center">-->
<!--          <p class="fw-bolder">فیلتر براساس دوره چرخه پیشرفت موردانتظار</p>-->
<!--          <select v-model="selectedPeriodIdForFilter" class="form-select" style="width: 12vw;">-->
<!--            <option v-for="item in all_periods" :value="item.id" :selected="item.status === 1 && !is_update">-->
<!--              {{ item.name }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </div>-->
<!--      </div>-->

      <div class="col-4">
        <div class="d-flex flex-column align-items-center">
          <p class="fw-bolder">فیلتر براساس وضعیت فعالیت</p>
          <select class="form-select" v-model="activityStatus" style="width: 12vw;">
            <option value="همه">همه</option>
            <option value="تکمیل شده">تکمیل شده</option>
            <option value="تکمیل نشده">تکمیل نشده</option>
          </select>
        </div>
      </div>
    </div>

    <center v-show="!allItemsTwoModal.length">
      اطلاعاتی یافت نشد
    </center>
    <div>
      <div style="overflow-y: scroll;height: 17vw; width: 100%;">
        <table class="table table-striped" v-show="all_keys.length">
          <tbody>
          <tr class="sticky-header">
            <th class="sticky-header"><strong> عنوان فعالیت </strong></th>
            <th class="sticky-header"><strong> دستگاه متولی </strong></th>
            <th class="sticky-header"><strong> دستگاه همکار </strong></th>
            <th class="sticky-header"><strong>دوره چرخه</strong></th>
            <th class="sticky-header"><strong> زمان شروع فعالیت </strong></th>
            <th class="sticky-header"><strong> زمان پایان فعالیت </strong></th>
            <th class="sticky-header"><strong> پیشرفت مورد انتظار فعالیت در پایان سال قبلی (%) </strong></th>
            <th class="sticky-header"><strong> پیشرفت مورد انتظار فعالیت در پایان بهار{{ year }} (%) </strong></th>
            <th class="sticky-header"><strong> پیشرفت مورد انتظار فعالیت در پایان تابستان{{ year }} (%) </strong></th>
            <th class="sticky-header"><strong> پیشرفت مورد انتظار فعالیت در پایان پاییز{{ year }} (%) </strong></th>
            <th class="sticky-header"><strong> پیشرفت مورد انتظار فعالیت در پایان سال{{ year }} (%) </strong></th>
            <th class="sticky-header"><strong>وزن </strong></th>
            <th class="sticky-header"><strong> عملیات </strong></th>

          </tr>
          </tbody>
          <tr v-for="(item,index) in all_keys" class="bg-white">
            <td>{{ item.title }}</td>
            <td>{{ item.trustee_device }}</td>
            <td>{{ item.partner_device }}</td>
            <td>{{ item?.event?.name ?? requestedYear }}</td>
            <td>{{ item.start_date }}</td>
            <td>{{ item.end_date }}</td>
            <td>{{ item?.previousProductivity?.progress_winter ?? '--' }}</td>
            <td>{{ item && item.productivity && item.productivity.progress_spring }}</td>
            <td>{{ item && item.productivity && item.productivity.progress_summer }}</td>
            <td>{{ item && item.productivity && item.productivity.progress_autumn }}</td>
            <td>{{ item && item.productivity && item.productivity.progress_winter }}</td>
            <td>{{ item && item.productivity && item.productivity.weight }}</td>

            <td>
              <div class="d-flex justify-content-evenly">
                <a @click.prevent="editKey(index)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg"
                                                                 alt="edit"></a>
                <a @click.prevent="deleteKeyModal(index)" href="#"><img class="table-delete-img"
                                                                        src="/img/delete.f9fc94bc.svg"
                                                                        alt="delete"></a>
              </div>
            </td>


          </tr>
        </table>
      </div>
      <hr class="mt-2 mb-2">
      <center v-show="all_keys.length">
        <button @click.prevent="store_twoModal" class="btn btn-primary btn-submit-1">ذخیره نهایی</button>
      </center>
    </div>
  </div>
  <hr v-if="allItems.length">
  <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-3">
    <a :href="`${this.download_url}/Definition_of_basic_measures/all/word/by/id/${id_route}?token=${$cookies.get('id_login')}`"
       style="margin-left: 1vw;margin-top: 1.3vw;"
       class="btn btn-primary btn-submit-1">خروجی Word</a>
    <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green "
       class="btn btn-primary btn-submit-1 "

       @click="acceptComplete"
    >
      <div v-if="!status_loading">

        <span>  تایید </span>
      </div>
      <div v-else>
        <div class="loader-line"></div>

      </div>
    </a>
    <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
       class="btn btn-primary btn-submit-1 "
       @click="acceptComplete2"
    >
      <div v-if="!status_loading2">
        <span>عدم تایید</span>
      </div>

      <div v-else>
        <div class="loader-line"></div>

      </div>
    </a>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModalKey" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="deleteModalKey=!deleteModalKey">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModalKey=!deleteModalKey" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteKey(index_key)">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="trusteeModal"
       style="z-index: 999999999999999; top: 50%; width: 85vw;">
    <div class="d-flex  w-100">
      <p>سنجه تحقق اقدام</p>
      <p @click="trusteeModal=!trusteeModal">❌</p>
    </div>
    <div>
      <div class="d-flex mb-3 ">
        <div class="d-flex flex-column mx-2 my-4">
          <label class="required"> عنوان سنجه اقدام </label>
          <input v-model="trustee_device" type="text" class="form-control">

        </div>
        <div class="d-flex flex-column mx-2">
          <label class="required"> ماهیت سنجه اقدام پیشرفت است؟ </label>
          <select v-model="nature_type" name="" id="" class="form-select">
            <option :value="1" selected>بله</option>
            <option :value="2">خیر</option>
          </select>

        </div>


        <div class="d-flex flex-column mx-2">
          <label class="required">هدف کمی/کیفی پایان اقدام</label>
          <input :disabled="nature_type===1" v-model="goal_end_action" type="text" class="form-control">

        </div>
        <div class="d-flex flex-column mx-2">
          <label class="required"> پیشرفت مورد انتظار در پایان بهار{{ year }} </label>
          <input v-if="spring" :disabled="nature_type===1" v-model="goal_spring" type="text" class="form-control">
          <input v-else disabled v-model="goal_spring" type="text" class="form-control">

        </div>
        <div class="d-flex flex-column mx-2">
          <label class="required"> پیشرفت مورد انتظار در پایان تابستان{{ year }} </label>
          <input v-if="summer" @change.prevent="validateSummerInput()" :disabled="nature_type===1" v-model="goal_summer"
                 type="text" class="form-control">
          <input v-else disabled type="text" class="form-control">

        </div>
        <div class="d-flex flex-column mx-2">
          <label class="required"> پیشرفت مورد انتظار در پایان پاییز{{ year }} </label>
          <input v-if="autumn" @change.prevent="validateFallInput()" :disabled="nature_type===1" v-model="goal_autumn"
                 type="text" class="form-control">
          <input v-else disabled type="text" class="form-control">

        </div>
        <div class="d-flex flex-column mx-2">
          <label class="required"> پیشرفت مورد انتظار در پایان سال{{ year }} </label>
          <input v-if="winter" @change.prevent="validateWinterInput()" :disabled="nature_type===1"
                 v-model="goal_end_year" type="text" class="form-control">
          <input v-else disabled type="text" class="form-control">

        </div>
      </div>
      <center class="d-flex mb-3">
        <button :disabled="checked_trustee && nature_type===2" v-if="!edit_trustee_status" @click.prevent="save"
                class="btn btn-submit-1 btn-primary mb-2">افزودن
        </button>
        <button v-if="edit_trustee_status" @click.prevent="edit" class="btn btn-submit-1 btn-primary mb-2">ویرایش
        </button>
        <Reset style="height: 2vw;" class="mx-2" @click.prevent="reset_trustee"/>
      </center>
      <div class="table-responsive" v-if="data.length">
        <div style="overflow-y: scroll; height: 15vw;" :style="data.length < 3 ? 'height: auto;' : ''">

          <table class="table table-striped">
            <tbody>
            <tr class="sticky-header">
              <th class="sticky-header"><strong> عنوان سنجه اقدام </strong></th>
              <th class="sticky-header"><strong> ماهیت سنجه اقدام پیشرفت است؟ </strong></th>
              <th class="sticky-header"><strong>هدف کمی/کیفی پایان اقدام</strong></th>
              <th class="sticky-header"><strong> پیشرفت مورد انتظار در پایان بهار{{ year }} </strong></th>
              <th class="sticky-header"><strong> پیشرفت مورد انتظار در پایان تابستان{{ year }} </strong></th>
              <th class="sticky-header"><strong> پیشرفت مورد انتظار در پایان پاییز{{ year }} </strong></th>
              <th class="sticky-header"><strong> پیشرفت مورد انتظار در پایان سال{{ year }} </strong></th>

              <th class="sticky-header"><strong> عملیات </strong></th>

            </tr>
            </tbody>
            <tr v-for="item in data">
              <td>{{ item.trustee_device }}</td>
              <td>{{ item.nature_type === 1 ? 'بله' : 'خیر' }}</td>
              <td>
                <span v-if="item.nature_type===1">
              100
                </span>
                <span v-else>
                      {{
                    (item.productivity && item.productivity.target) ? item.productivity.target : '--'
                  }}
               </span>
              </td>
              <td>{{
                  item.productivity && item.productivity.progress_spring ? item.productivity.progress_spring : '--'
                }}
              </td>
              <td>{{
                  item.productivity && item.productivity.progress_summer ? item.productivity.progress_summer : '--'
                }}
              </td>
              <td>{{
                  item.productivity && item.productivity.progress_autumn ? item.productivity.progress_autumn : '--'
                }}
              </td>
              <td>{{
                  item.productivity && item.productivity.progress_winter ? item.productivity.progress_winter : '--'
                }}
              </td>
              <td>
                <div class="d-flex justify-content-evenly">
                  <a @click.prevent="edit_trustee(item)" href="#"><img class="table-edit-img"
                                                                       src="/img/pen.6428fd02.svg"
                                                                       alt="edit"></a>
                  <a @click.prevent="deleteItemFormTrusteeModalMethod(item.id)" href="#"><img class="table-delete-img"
                                                                                              src="/img/delete.f9fc94bc.svg"
                                                                                              alt="delete"></a>
                </div>
              </td>

            </tr>

          </table>
        </div>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="trusteeModal=!trusteeModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteItemFormTrusteeModal"
       style="z-index: 9999999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="deleteItemFormTrusteeModal=!deleteItemFormTrusteeModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteItemFormTrusteeModal=!deleteItemFormTrusteeModal" class="btn btn-primary btn-back"
                type="submit">برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="deleteItemFormTrustee()">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalNama"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر ها </p>
      <p @click="allItemsModalNama=!allItemsModalNama">❌</p>
    </div>
    <div v-if="nama_all.length" class="bg-white p-2 rounded " style="overflow-y:scroll; width: 100%; height: 10vw;">
      <div class="table-responsive w-100">
        <table class="table table-striped">
          <thead>
          <tr class="sticky-header">
            <th>ردیف</th>
            <th>نماگر</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in nama_all" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item['title_photographer'] }}</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";

const toast = useToast();

export default {
  components: {Reset, Vue3PersianDatetimePicker},
  data() {
    return {
      //**************
      
      selectedPeriodId: null,
      selectedPeriodIdForFilter: null,
      all_periods: [],
      requestedYear: '',
      nature_type: 1,
      trustee_id_edit: '',
      trustee_id: '',
      nature_size: '',
      nature_title: '',
      trusteeModal: false,
      deleteItemFormTrusteeModal: false,
      edit_trustee_status: false,
      propulsion_id: null, // مقدار پیش‌فرض
      goal_end_action: '',
      goal_spring: '',
      goal_summer: '',
      goal_autumn: '',
      goal_end_year: '',
      id_nature: '',
      data: [], // داده‌های سنجه‌ها
      //**************
      deleteModal: false,
      deleteModalKey: false,
      PropulsionModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      is_updateKey: false,
      allItems: [],
      id: '',
      id_two: '',
      id_itemKey: '',
      // stage 1
      allItemsOneModal: [],
      title: '',
      service: '',
      start_date: '',
      end_date: '',
      gauge: '',
      target: '',
      //stage 2
      allItemsTwoModal: [],
      allItemsTreeModal: [],
      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      id_route: this.$route['params']['id'],
      id_user: '',
      title_PropulsionBasicAction: '',
      start_date_PropulsionBasicAction: '',
      end_date_PropulsionBasicAction: '',
      realization_PropulsionBasicAction: '',
      is_update: false,
      id_item: '',
      target_PropulsionBasicAction: '',
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessageShow: '',
      modalMessage: false,
      modalMessageShowModal: false,
      status_loading2: false,
      spring: false,
      summer: false,
      autumn: false,
      winter: false,
      year: '',
      index_key: '',
      weight: '',
      expected_progress_spring: '',
      expected_progress_summer: '',
      expected_progress_fall: '',
      all_keys: [],
      all_keys_deleted: [],
      allItemsKeys: [],
      activityStatus: 'تکمیل نشده',
      allItemsModalNama: false,
      nama_all: [],
    }
  },
  methods: {

    
    validateSeasonProgress(seasonName, currentProgress, previousProgress = null) {
      /*  if (currentProgress < 0 || currentProgress > 100) {
          toast.error(`عدد وارد شده برای ${seasonName} باید بین 0 و 100 باشد`);
          return false;
        }*/

      if (previousProgress !== null && parseFloat(currentProgress) < parseFloat(previousProgress)) {
        toast.error(`پیشرفت ${seasonName} نمی‌تواند از فصل قبلی کمتر باشد`);
        return false;
      }

      return true;
    },

   showAllNama(id) {
      fetch(`${this.base_url}/problem-photographers/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`

        },

      })
          .then(response => {
            return response.json()

          })
          .then(data => {
            this.nama_all = data.all
            this.allItemsModalNama = true
          })
          .catch(error => {
            toast.error(error)
          });
    },

    validateAllSeasons() {
      this.checked_trustee = false; // همه اعتبارسنجی‌ها موفق بودند

    },

    validateSummerInput() {
      this.validateAllSeasons(); // فقط اعتبارسنجی کلی را فراخوانی کنید
    },

    validateFallInput() {
      this.validateAllSeasons(); // فقط اعتبارسنجی کلی را فراخوانی کنید
    },

    validateWinterInput() {
      this.validateAllSeasons(); // فقط اعتبارسنجی کلی را فراخوانی کنید
    },

    fetchData(id) {
      this.trusteeModal = true
      this.trustee_id = id

      fetch(`${this.base_url}/trustee-actions/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`

        },

      })
          .then(response => {
            return response.json()

          })
          .then(data => {
            this.data = data.all
            if (data.year) {
              this.year = data.year
            }
          })
          .catch(error => {
            toast.error('خطا در افزودن سنجه، لطفاً دوباره تلاش کنید.');
          });
    },
    reset_trustee() {
      this.trustee_device = ''
      this.nature_type = 1
      this.goal_end_action = ''
      this.goal_spring = ''
      this.goal_summer = ''
      this.goal_autumn = ''
      this.goal_end_year = ''
      this.edit_trustee_status = false
      this.checked_trustee = true

    },
    edit_trustee(item) {
      this.trustee_id_edit = item.id
      this.trustee_device = item.trustee_device
      this.nature_type = item.nature_type
      this.goal_end_action = item.goal_end_action
      this.goal_spring = item.goal_spring
      this.goal_summer = item.goal_summer
      this.goal_autumn = item.goal_autumn
      this.goal_end_year = item.goal_end_year
      this.edit_trustee_status = true
    },

    save() {
      if (!this.trustee_device) {
        toast.error('عنوان سنجه اقدام اجباری است!')
        return
      }


      const payload = {
        propulsion_id: this.trustee_id,
        trustee_device: this.trustee_device,
        nature_type: this.nature_type,
        goal_end_action: this.goal_end_action, // باید در data تعریف شده باشد
        goal_spring: this.goal_spring, // باید در data تعریف شده باشد
        goal_summer: this.goal_summer, // باید در data تعریف شده باشد
        goal_autumn: this.goal_autumn, // باید در data تعریف شده باشد
        goal_end_year: this.goal_end_year // باید در data تعریف شده باشد
      };

      fetch(`${this.base_url}/trustee-actions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`

        },
        body: JSON.stringify(payload)
      })
          .then(response => {

            return response.json();
          })
          .then((data) => {
            if (data.error) {
              toast.error(data.error);
              return
            }

            toast.success('سنجه با موفقیت افزوده شد.');
            this.trusteeModal = false; // بستن مودال
            this.fetchData(this.trustee_id); // به‌روزرسانی داده‌ها
            this.reset_trustee(); // به‌روزرسانی داده‌ها
          })
          .catch(error => {
            console.error(error);
            toast.error('خطا در افزودن سنجه، لطفاً دوباره تلاش کنید.');
          });
    },
    edit() {
      if (!this.trustee_device) {
        toast.error('عنوان سنجه اقدام اجباری است!')
        return
      }
      const payload = {
        propulsion_id: this.trustee_id,
        trustee_device: this.trustee_device,
        nature_type: this.nature_type,
        goal_end_action: this.goal_end_action,
        goal_spring: this.goal_spring,
        goal_summer: this.goal_summer,
        goal_autumn: this.goal_autumn,
        goal_end_year: this.goal_end_year
      };

      fetch(`${this.base_url}/trustee-actions/${this.trustee_id_edit}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`

        },
        body: JSON.stringify(payload)
      })
          .then(response => {
            if (!response.ok) {
              throw new Error('خطا در ویرایش سنجه');
            }
            return response.json();
          })
          .then(data => {
            toast.success('سنجه با موفقیت ویرایش شد.');
            this.trusteeModal = false; // بستن مودال
            this.fetchData(this.trustee_id); // به‌روزرسانی داده‌ها
            this.reset_trustee(); // به‌روزرسانی داده‌ها

          })
          .catch(error => {
            console.error(error);
            alert('خطا در ویرایش سنجه، لطفاً دوباره تلاش کنید.');
          });
    },
    deleteItemFormTrusteeModalMethod(id) {
      this.deleteItemFormTrusteeModal = true
      this.id_nature = id
    },
    deleteItemFormTrustee() {

      fetch(`${this.base_url}/trustee-actions/${this.id_nature}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`

        }
      })
          .then(response => {
            if (!response.ok) {
              throw new Error('خطا در حذف سنجه');
            }
            return response.json();
          })
          .then(data => {
            toast.success('سنجه با موفقیت حذف شد.');
            this.deleteItemFormTrusteeModal = false

            this.fetchData(this.trustee_id); // به‌روزرسانی داده‌ها
          })
          .catch(error => {
            console.error(error);
            alert('خطا در حذف سنجه، لطفاً دوباره تلاش کنید.');
          });
    },
    update_Key(id) {
      if (!this.title_task) {
        toast.error('عنوان فعالیت اجباری است')
        return;
      } else if (!this.trustee_device) {
        toast.error('دستگاه متولی اجباری است')
        return;
      } else if (!this.partner_device) {
        toast.error('دستگاه همکار اجباری است')
        return;
      } else if (parseInt(this.expected_progress) > 100) {
        toast.error('پیشرفت مورد انتظار در پایان سال نمی تواند  بیشتر از 100 درصد باشد')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('propulsion_basic_actions_id', this.id_tree)
      formdata.append('title', this.title_task)
      formdata.append('trustee_device', this.trustee_device)
      formdata.append('partner_device', this.partner_device)
      formdata.append('start_date', this.start_date_task)
      formdata.append('end_date', this.end_date_task)
      formdata.append('expected_progress', this.expected_progress)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title_task = ''
            this.trustee_device = ''
            this.partner_device = ''
            this.start_date_task = ''
            this.end_date_task = ''
            this.expected_progress = ''
            this.all_twoModal()
            this.is_updateKey = false


          })
          .catch();
    },

    resetItemsKey() {
      this.selectedPeriodId = this.activePeriod.id;
      this.is_updateKey = false
      this.title_task = ''
      this.trustee_device = ''
      this.partner_device = ''
      this.start_date_task = ''
      this.end_date_task = ''
      this.expected_progress = ''
      this.id_itemKey = ''
      this.expected_progress_spring = ''
      this.expected_progress_summer = ''
      this.expected_progress_fall = ''
      this.weight = ''
    },
    // keys

    validateFields() {
      if (!this.title_task) {
        toast.error('عنوان وظیفه اجباری است!');
        return false;
      }
      if (!this.trustee_device) {
        toast.error('دستگاه متولی اجباری است!');
        return false;
      }
      if (!this.partner_device) {
        toast.error('دستگاه همکار اجباری است!');
        return false;
      }
      if (!this.start_date_task) {
        toast.error('تاریخ شروع اجباری است!');
        return false;
      }
      if (!this.end_date_task) {
        toast.error('تاریخ پایان اجباری است!');
        return false;
      }

      // Validate each season independently with null and length check
      if (!this.weight) {
        toast.error('وزن اجباری است!');
        return false;
      }
      if (this.spring) {
        if (!this.expected_progress_spring || this.expected_progress_spring.length === 0) {
          toast.error('پیشرفت مورد انتظار بهار اجباری است!');
          return false;
        }
      }
      if (this.summer) {
        if (!this.expected_progress_summer || this.expected_progress_summer.length === 0) {
          toast.error('پیشرفت مورد انتظار تابستان اجباری است!');
          return false;
        }
        if (this.expected_progress_spring !== null && this.expected_progress_summer < this.expected_progress_spring) {
          toast.error('پیشرفت تابستان نمی‌تواند از بهار کمتر باشد');
          return false;
        }
      }
      if (this.autumn) {
        if (!this.expected_progress_fall || this.expected_progress_fall.length === 0) {
          toast.error('پیشرفت مورد انتظار پاییز اجباری است!');
          return false;
        }
        if (this.expected_progress_summer !== null && this.expected_progress_fall < this.expected_progress_summer) {
          toast.error('پیشرفت پاییز نمی‌تواند از تابستان کمتر باشد');
          return false;
        }
      }
      if (this.winter) {
        if (this.expected_progress === null || parseFloat(this.expected_progress) === 0) {
          toast.error('پیشرفت مورد انتظار زمستان اجباری است!');
          return false;
        }
        if (this.expected_progress_fall !== null && parseInt(this.expected_progress) < parseInt(this.expected_progress_fall)) {
          toast.error('پیشرفت زمستان نمی‌تواند از پاییز کمتر باشد');
          return false;
        }
      }


      return true;
    },
    resetKey() {
      this.selectedPeriodId = this.activePeriod.id
      this.title_task = ''
      this.trustee_device = ''
      this.partner_device = ''
      this.start_date_task = ''
      this.end_date_task = ''
      this.expected_progress = ''
      this.expected_progress_spring = ''
      this.expected_progress_summer = ''
      this.expected_progress_fall = ''
      this.weight = ''
      this.expected_progress_spring = ''
      this.expected_progress_summer = ''
      this.expected_progress_fall = ''
    },
    editKey(index) {
      let key = this.all_keys[index];
      this.id_key = key.id
      this.id_two = key.problem_identification_id;
      this.id_tree = key.propulsion_basic_actions_id;
      this.title_task = key.title;
      this.trustee_device = key.trustee_device;
      this.partner_device = key.partner_device;
      this.start_date_task = key.start_date;
      this.end_date_task = key.end_date;
      this.expected_progress = key.productivity && key.productivity.progress_winter;
      this.expected_progress_spring = key.productivity && key.productivity.progress_spring;
      this.expected_progress_summer = key.productivity && key.productivity.progress_summer;
      this.expected_progress_fall = key.productivity && key.productivity.progress_autumn;
      this.weight = key.productivity && key.productivity.weight;
      this.index_key = index
      this.is_updateKey = true
    },
    deleteKeyModal(index) {
      this.deleteModalKey = true
      this.index_key = index
    },
    deleteKey(index) {
      if (this.all_keys[index]) { // بررسی وجود عنصر در این ایندکس
        this.all_keys_deleted.push(this.all_keys[index].id);
        this.all_keys.splice(index, 1);
        toast.success('با موفقیت حذف شد!');
        this.deleteModalKey = false;
      } else {
        this.deleteModalKey = false;
        toast.error('ورودی نامعتبر است!');
      }

    },
    updateKey(index) {
      if (!this.validateFields()) {
        return;
      }
      this.all_keys[index] = {
        'id': this.id_key,
        'problem_identification_id': this.id_two,
        'propulsion_basic_actions_id': this.id_tree,
        'title': this.title_task,
        'trustee_device': this.trustee_device,
        'partner_device': this.partner_device,
        'event_id': this.selectedPeriodId,
        'event': this.all_periods.find(period => period.id === this.selectedPeriodId),
        'start_date': this.start_date_task,
        'end_date': this.end_date_task,
        'productivity': {
          'progress_spring': this.expected_progress_spring,
          'progress_summer': this.expected_progress_summer,
          'progress_autumn': this.expected_progress_fall,
          'progress_winter': this.expected_progress,
          'weight': this.weight,
          'event_id': this.selectedPeriodId,
          'event': this.all_periods.find(period => period.id === this.selectedPeriodId),
        },
        'expected_progress_spring': this.expected_progress,
        'expected_progress_summer': this.expected_progress_spring,
        'expected_progress_fall': this.expected_progress_summer,
        'expected_progress': this.expected_progress_fall,
        'weight': this.weight,
      };
      toast.success('با موفقیت به‌روزرسانی شد!');
      this.is_updateKey = false
      this.resetKey()
    },
    saveKeys() {
      const obj = {
        'problem_identification_id': this.id_two,
        'propulsion_basic_actions_id': this.id_tree,
        'title': this.title_task,
        'trustee_device': this.trustee_device,
        'partner_device': this.partner_device,
        'event_id': this.selectedPeriodId,
        'event': this.all_periods.find(period => period.id === this.selectedPeriodId),
        'start_date': this.start_date_task,
        'end_date': this.end_date_task,
        'expected_progress': this.expected_progress,
        'expected_progress_spring': this.expected_progress_spring,
        'expected_progress_summer': this.expected_progress_summer,
        'expected_progress_fall': this.expected_progress_fall,
        'weight': this.weight,
        'productivity': {
          'progress_spring': this.expected_progress_spring,
          'progress_summer': this.expected_progress_summer,
          'progress_autumn': this.expected_progress_fall,
          'progress_winter': this.expected_progress,
          'weight': this.weight,
          'event_id': this.selectedPeriodId,
          'event': this.all_periods.find(period => period.id === this.selectedPeriodId),
        },
      }
      this.all_keys.push(obj);
      toast.success('با موفقیت به لیست اضافه شد!');
      this.resetKey()
    },


    store_twoModal() {

      if (this.all_keys.length === 0) {
        toast.error('حداقل یک فعالیت کلیدی اجباری است!');
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('keys', JSON.stringify(this.all_keys));
      // Fixed the line below by removing the extra 'this'
      formdata.append('all_keys_deleted', JSON.stringify(this.all_keys_deleted));
      formdata.append('propulsion_basic_actions_id', this.id_tree);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      fetch(`${this.base_url}/KeyActivitiesProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success(response.message);
            this.title_task = '';
            this.trustee_device = '';
            this.partner_device = '';
            this.start_date_task = '';
            this.end_date_task = '';
            this.weight = '';
            this.expected_progress = '';
            this.expected_progress_spring = '';
            this.expected_progress_summer = '';
            this.expected_progress_fall = '';
            this.all_twoModal();
          })
          .catch(error => {
            console.error('Error:', error); // It's good practice to log the error
            toast.error('An error occurred while processing your request.');
          });
    },

    store_oneModal() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('problem_identifications_id', this.id)
      formdata.append('title', this.title)
      formdata.append('service', this.service)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('gauge', this.gauge)
      formdata.append('target', this.target)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/mission_problems/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title = ''
            this.service = ''
            this.start_date = ''
            this.end_date = ''
            this.gauge = ''
            this.target = ''
            this.all_oneModal()

          })
          .catch();
    },

    all_twoModal() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('activity_status', this.activityStatus)
      formdata.append('period_id', this.selectedPeriodIdForFilter)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/all/${this.id_tree}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.all_keys.length = 0
            this.allItemsTwoModal.length = 0
            response.all.forEach((ele) => {
              this.allItemsTwoModal.push(ele)
              this.all_keys.push(ele)
            })
            this.requestedYear = response?.requested_year
            if (response.year) {
              this.year = response.year
            }
          })
          .catch();
    },
    editMethodKey(id) {
      this.id_itemKey = id
      this.is_updateKey = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/KeyActivitiesProblem/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item) {
              this.is_update = true
              this.title_task = response.item.title
              this.trustee_device = response.item.trustee_device
              this.partner_device = response.item.partner_device
              this.start_date_task = response.item.start_date
              this.end_date_task = response.item.end_date
              this.expected_progress = response.item.expected_progress

            }
          })
          .catch();
    },
    deleteMethodKey(id) {
      this.id_itemKey = id
      this.deleteModalKey = true

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_all_destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              toast.success(response.message)

              this.all_TreeModal(response.id)

              this.id_item = ''
              this.deleteModal = false

            }
          })
          .catch();
    },
    deleteItemFormKey(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/KeyActivitiesProblem/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              this.deleteModalKey = false
              this.id_itemKey = false
              this.all_twoModal()
              toast.success(response.message)

            }
          })
          .catch();
    },
    acceptComplete() {
      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2() {

      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    checkKeysClose() {
      /*  let number = 0
        this.allItemsTwoModal.forEach((item)=>{
          number+=parseInt(item.expected_progress)
        })

        if (number>100){
          toast.error('مجموع حاصل جمع پیشرفت مورد انتظار در سال نباید بیشتر از 100  باشد!')
          return;
        }*/
      this.KeyDefinitionsModal = !this.KeyDefinitionsModal
    },
    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/BasicMeasuresProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    resetData() {
      this.selectedPeriodId = this.activePeriod.id;
      this.title_PropulsionBasicAction = ''
      this.start_date_PropulsionBasicAction = ''
      this.end_date_PropulsionBasicAction = ''
      this.realization_PropulsionBasicAction = ''
      this.target_PropulsionBasicAction = ''
      this.nature_type = ''
      this.nature_size = ''
      this.nature_title = ''
      this.status_project = ''
    },
    all_TreeModal(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsTreeModal.length = 0
            response.all.forEach((ele) => {
              this.allItemsTreeModal.push(ele)
            })


          })
          .catch();
    },
    resetItems() {
      this.resetData()
      this.selectedPeriodId = this.activePeriod.id;
      this.is_update = false
      this.id_item = ''
    },
    update_PropulsionBasicAction(id) {
      if (!this.id_item) {
        toast.error('درخواست نامعتبر!')
        return;
      }
      if (!this.title_PropulsionBasicAction.length) {
        toast.error('اقدام پیشران اجباری است')
        return;
      }
      if (!this.start_date_PropulsionBasicAction.length) {
        toast.error('تاریخ شروع   اجباری است')
        return;
      }
      if (!this.end_date_PropulsionBasicAction.length) {
        toast.error('تاریخ پایان   اجباری است')
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_PropulsionBasicAction)
      formdata.append('date_start', this.start_date_PropulsionBasicAction)
      formdata.append('date_end', this.end_date_PropulsionBasicAction)
      formdata.append('realization', this.realization_PropulsionBasicAction)
      formdata.append('target', this.target_PropulsionBasicAction)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_all_update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all_TreeModal(response.id)
            this.resetItems()

          })
          .catch();
    },
    store_PropulsionBasicAction_store() {
      if (!this.title_PropulsionBasicAction.length) {
        toast.error('اقدام پیشران اجباری است')
        return;
      }
      if (!this.start_date_PropulsionBasicAction.length) {
        toast.error('تاریخ شروع   اجباری است')
        return;
      }
      if (!this.end_date_PropulsionBasicAction.length) {
        toast.error('تاریخ پایان   اجباری است')
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('problem_identifications_id', this.id_two)
      formdata.append('title', this.title_PropulsionBasicAction)
      formdata.append('date_start', this.start_date_PropulsionBasicAction)
      formdata.append('date_end', this.end_date_PropulsionBasicAction)
      formdata.append('realization', this.realization_PropulsionBasicAction)
      formdata.append('target', this.target_PropulsionBasicAction)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

            this.all_TreeModal(this.id_two)
            this.resetData()
            // this.all_TreeModal()

          })
          .catch();
    },


    all_oneModal() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/mission_problems/all/${this.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsOneModal.length = 0
            response.all.forEach((ele) => {
              this.allItemsOneModal.push(ele)
            })


          })
          .catch();
    },


    CompleteMission(id) {
      this.id = id
      this.all_oneModal()
      this.MissionModal = true

    },
    deleteMethod(id) {
      this.id_item = id
      this.deleteModal = true
    },
    editMethod(id) {
      this.id_item = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_all_edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item) {
              this.is_update = true
              this.title_PropulsionBasicAction = response.item.title
              this.start_date_PropulsionBasicAction = response.item.date_start
              this.end_date_PropulsionBasicAction = response.item.date_end
              this.realization_PropulsionBasicAction = response.item.realization
              this.target_PropulsionBasicAction = response.item.target

            }
          })
          .catch();

    },
    CompleteKeyDefinitions(id) {

      this.id_tree = id
      this.all_twoModal()
      this.KeyDefinitionsModal = true

    },
    CompletePropulsionModal(id) {
      this.id_two = id
      this.PropulsionModal = true
      this.all_TreeModal(id)

    },
    all() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status) {
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {

              this.allItems.push(item)

            })
            if (response.message) {
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
          })
          .catch();
    },
    store() {
      let obj = []
      this.allItems.forEach((item) => {
        const title_two = document.getElementById(`title_two_${item.id}`).value

        let record = {
          'problem_identifications_id': item.id,
          'intervention_policy': title_two,

          'id': item.basic_measures_problem ? item.basic_measures_problem.id : null
        }
        obj.push(record)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

          })
          .catch();
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
              } else {
                this.id_user = result['item']['company_id']
              }
            }

          })
          .catch();
    },
    fetchPeriodKnow() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('sange', '')

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/habits_know`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            this.spring = response.spring
            this.summer = response.summer
            this.autumn = response.autumn
            this.winter = response.winter

          })
          .catch();
    },

    allItemsKeysMethod() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/KeyActivitiesProblem/all_itemsKeys/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsKeys.length = 0

            this.allItemsKeys = response.all


          })
          .catch();
    },
    allPeriods() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('sange', '')


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod`, requestOptions)
          .then(response => response.json())
          .then(async response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.all) {
              this.all_periods.length = 0
              await response.all.forEach((ele) => {
                this.all_periods.push(ele)
              })
              this.selectedPeriodId = this.activePeriod.id;
              this.selectedPeriodIdForFilter = this.activePeriod.id;
            }

          })
          .catch();
    },
  },
  computed: {
    sortedItems() {
      return this.allItemsKeys
          .filter(item => item.title !== '--')
          .sort((a, b) => a.title.localeCompare(b.title));
    },
    activePeriod() {
      return this.all_periods.find(period => period.status === 1)
    },
  },
  mounted() {
    this.allPeriods()
    this.all()
    this.fetchPeriodKnow()
    this.allItemsKeysMethod()
  },
  watch: {
    activityStatus: function () {
      this.all_twoModal();
    },
    selectedPeriodIdForFilter: function () {
      this.all_twoModal();
    },
  }
}
</script>
<style scoped>
.key-definitions-modal label {
  font-size: .9vw !important;
}
</style>